import { Button, Modal, Row, Tag } from "antd";
import { useCallback, useMemo } from "react";
import "./ViewMoreFilter.css";
import { CloseOutlined } from "@ant-design/icons";
import { clearAllFilters as clearAllProductFilters } from "../../../store/slices/common-slice/product-filters/ProductFilter";
import { clearSelectedDMAs } from "../../../store/thunks/common-thunks/Actions";
import { useDispatch } from "react-redux";
const ViewMoreFilter = ({
  isOpen,
  onClose,
  selectedDMAs,
  handleClose,
  items,
  showNearby,
}) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const combinedTags = [
    ...(items || []),
    ...(showNearby ? [] : selectedDMAs || []),
  ];
  const dispatch = useDispatch();
  //Clearing the all filter bulk
  const handleDeleteAll = useCallback(() => {
    dispatch(clearAllProductFilters());
    dispatch(clearSelectedDMAs());
    onClose();
  }, [dispatch, onClose]);

  const tags = useMemo(() => {
    return (
      <div className="filter-tags">
        {[...combinedTags]
          .sort((a, b) => {
            const labelA = (a?.label || "Unknown").toLowerCase();
            const labelB = (b?.label || "Unknown").toLowerCase();
            return labelA.localeCompare(labelB);
          })
          ?.map((item, index) => (
            <Tag
              key={`${item?.title || "dma"}-${
                item?.id ?? item?.label
              }-${index}`}
              closable
              onClose={() => handleClose(item)}
              closeIcon={<CloseOutlined />}
              color="#d2042d"
            >
              {item?.label || "Unknown"}
            </Tag>
          ))}
      </div>
    );
  }, [combinedTags, handleClose]);

  return (
    <div>
      <Modal
        open={isOpen}
        onCancel={onClose}
        title={"Filters You've Applied"}
        footer={
          <Button
            type="primary"
            onClick={handleDeleteAll}
            className="view-more-filter-clear-button"
          >
            Clear All
          </Button>
        }
        placement="right"
        className="view-more-filter-modal"
      >
        <div className="view-more-filter-content">
          <Row>{tags}</Row>
        </div>
      </Modal>
    </div>
  );
};
export default ViewMoreFilter;
